import React, { useRef, useState } from "react";
import {
  FieldButtonGroup,
  DatePicker,
  FieldDropSide,
  SliderPanel,
  FieldInput,
  FieldInputNumber,
  AddPlans,
  CsplTable as Table,
  FormControlSearch,
  Link,
  FieldInputPercentage,
} from "../";
import { isEmpty, get, uniqBy, uniq, uniqWith, isEqual } from "lodash";
import { useDeepEffect } from "../../abstracts";
import { Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

function DifferentParticipantElectionTable(props) {
  const {
    headerData = [],
    actualData = [],
    onDeleteClick,
    errorMsg,
    Invsum,
    AddName,
    values,
    isEdit,
    isSave,
    index,
    investmentBasedOn = 0,
    sourceId,
    sourceName,
    isAdditionalAutoenrollmentDiffSource,
    isAdditionalAutoenrollmentSameSource,
  } = props;
  const subTable = get(headerData, "1.subTable", []);
  const showErrorMsg =
    subTable.filter((item, cellIndex) => Invsum(index, cellIndex) != 100)
      .length != 0;

  return (
    <div className="different-participant-election-table">
      <Table className="different-participants-election-table main-table">
        <Table.Thead>
          <div
            className="d-flex w-100"
            style={{
              flexDirection: "column",
            }}
          >
            <Table.Tr>
              {headerData.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>

            <div style={{ height: "100px", width: "100%" }}></div>
          </div>
        </Table.Thead>
        <Table.Tbody>
          {actualData.map((investment, sourceInd) => {
            return (
              <Table.Tr key={sourceInd}>
                {headerData.map((item, cellIndex) => {
                  const getContent = () => {
                    if (item.columnName == "Investment") {
                      return investment.investmentName ?? investment.name;
                    }
                    if (item.columnName == "Action") {
                      return (
                        <Link>
                          <FontAwesomeIcon
                            icon={faTrashAlt}
                            color="red"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                onDeleteClick(
                                  investment.investmentName ?? investment.name,
                                  investmentBasedOn,
                                  index,
                                  cellIndex,
                                  sourceInd
                                );
                            }}
                          />
                        </Link>
                      );
                    }
                    return <></>;
                  };

                  return (
                    <Table.Td key={cellIndex} className={item.className}>
                      {getContent()}
                    </Table.Td>
                  );
                })}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
        <div className="line-separator-total" />
        <Table.Tbody className="main-table-last-row">
          <div style={{ height: showErrorMsg ? 160 : 70 }}>
            <Table.Tr>
              {headerData.map((item, cellIndex) => {
                const getContent = () => {
                  if (item.columnName == "Investment") {
                    return "Total";
                  }
                  if (item.columnName == "Action") {
                    return null;
                  }
                  return <></>;
                };

                return (
                  <Table.Td key={cellIndex} className={item.className}>
                    {getContent()}
                  </Table.Td>
                );
              })}
            </Table.Tr>
          </div>
        </Table.Tbody>
      </Table>
      <div className="sub-table-parent">
        <Table className="sub-table">
          <div className="sub-table-child">
            {" "}
            {/* subtable */}
            <Table.Thead>
              {
                <Table.Tr>
                  {subTable.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              }
            </Table.Thead>
            <Table.Tbody>
              {actualData.map((investment, sourceInd) => {
                return (
                  <Table.Tr key={sourceInd}>
                    {subTable.map((item, cellIndex) => {
                      const actualCellIndex =
                        item.label === "Default" ? 0 : cellIndex + 1;
                      const fieldName = isAdditionalAutoenrollmentSameSource
                        ? `additionalAutoEnrollmentCategorywiseInvestment[${actualCellIndex}][${sourceInd}].investmentPercentage`
                        : isAdditionalAutoenrollmentDiffSource
                        ? `additionalAutoEnrollmentDifferentInvestmentElection[${index}][${actualCellIndex}][${sourceInd}].investmentPercentage`
                        : `autoEnrollment.differentInvestmentElection[${index}][${actualCellIndex}][${sourceInd}].investmentPercentage`;
                      const getContent = () => {
                        return (
                          <Field
                            size="xxs"
                            isRequired
                            name={fieldName}
                            hasSuggestion
                            shouldDisplaySuggestion
                            component={FieldInputPercentage}
                            type="number"
                            value={get(values, fieldName)}
                            onChange={(e) => {
                              if (isAdditionalAutoenrollmentSameSource)
                                AddName(
                                  e,
                                  investment.name,
                                  investment.id,
                                  actualCellIndex,
                                  sourceInd,
                                  item.columnName,
                                  investmentBasedOn
                                );
                              else if (isAdditionalAutoenrollmentDiffSource)
                                AddName(
                                  e,
                                  investment.id,
                                  investment.investmentName ?? investment.name,
                                  index,
                                  actualCellIndex,
                                  sourceInd,
                                  item.columnName,
                                  sourceId,
                                  sourceName,
                                  investmentBasedOn
                                );
                              else if (
                                sourceId !== null &&
                                sourceId !== undefined
                              )
                                AddName(
                                  e,
                                  investment.investmentId,
                                  investment.investmentName ?? investment.name,
                                  index,
                                  actualCellIndex,
                                  sourceInd,
                                  item.columnName,
                                  sourceId,
                                  sourceName,
                                  investmentBasedOn
                                );
                              else
                                AddName(
                                  e,
                                  investment.investmentId,
                                  investment.investmentName ?? investment.name,
                                  0, //index
                                  actualCellIndex,
                                  sourceInd,
                                  item.columnName,
                                  investmentBasedOn,
                                  `autoEnrollment.differentInvestmentElection[${index}][${actualCellIndex}][${sourceInd}]`
                                );
                            }}
                            disabled={isEdit && !isSave}
                            autoComplete="off"
                            validate={(value) =>
                              [null, undefined].includes(get(values, fieldName))
                                ? "PL545 : Required"
                                : undefined
                            }
                          />
                        );
                      };

                      return (
                        <Table.Td
                          key={actualCellIndex}
                          className={item.className}
                        >
                          {getContent()}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
            <div className="line-separator-total" />
            <Table.Tbody>
              <div>
                <Table.Tr className="total-box-cell">
                  {subTable.map((item, cellIndex) => {
                    const actualCellIndex =
                      item.label === "Default" ? 0 : cellIndex + 1;
                    const getContent = () => {
                      if (item.columnName == "Investment") {
                        return "Total";
                      }
                      if (item.columnName == "Action") {
                        return null;
                      }
                      return (
                        <div>
                          <Field
                            size="xxs"
                            isRequired
                            name="totalBox"
                            hasSuggestion
                            shouldDisplaySuggestion
                            component={FieldInputPercentage}
                            type="number"
                            value={Invsum(index, actualCellIndex)}
                            autoComplete="off"
                            disabled
                            // validate={(value) => {
                            //   return Invsum(index, cellIndex - 1) != 100
                            //     ? "PL545 : The total value of investment election is not totaling to 100%"
                            //     : undefined;
                            // }}
                          />
                          <p className="error-message-style">
                            {errorMsg(Invsum(index, actualCellIndex))}
                          </p>
                        </div>
                      );
                    };

                    return (
                      <Table.Td
                        key={actualCellIndex}
                        className={item.className}
                      >
                        {getContent()}
                      </Table.Td>
                    );
                  })}
                </Table.Tr>
              </div>
            </Table.Tbody>
          </div>
        </Table>
      </div>
    </div>
  );
}

export default DifferentParticipantElectionTable;
